import formatTableJson from '@manage/config/tableComponentParams.js'
export default formatTableJson([
  {
    filed: 'name',
    label: '版本名称'
  },
  {
    filed: 'code',
    label: '版本号'
  },
  {
    filed: 'typeName',
    label: 'APP类型'
  },
  {
    filed: 'remark',
    label: '版本说明'
  },
  {
    filed: 'createTime',
    label: '版本发布日期',
    type: 'time',
    width: '170'
  }
])
